import React, { useMemo } from "react";
import { ExternalLink, Share2 } from "lucide-react";
import PreviewModalShell from "./_PreviewModalShell";

function socialList(data) {
  const out = [];
  if (data.facebook?.trim()) out.push({ label: "Facebook", url: data.facebook.trim() });
  if (data.instagram?.trim()) out.push({ label: "Instagram", url: data.instagram.trim() });
  if (data.tiktok?.trim()) out.push({ label: "TikTok", url: data.tiktok.trim() });
  if (data.youtube?.trim()) out.push({ label: "YouTube", url: data.youtube.trim() });
  return out;
}

export default function FooterPreviewModal({ data, onClose }) {
  const siteName = (data.siteName || "").trim() || "— Chưa nhập tên site —";
  const hotline = (data.hotline || "").trim();
  const email = (data.email || "").trim();
  const address = (data.address || "").trim();

  const socials = useMemo(() => socialList(data), [data]);

  return (
    <PreviewModalShell
      icon={<Share2 size={17} />}
      title="Preview footer"
      subtitle="Mạng xã hội hiển thị ở footer."
      onClose={onClose}
    >
      <div className="space-y-3">
        <p className="text-xs text-slate-500">Chân trang thường có tên site, liên hệ và icon mạng xã hội.</p>

        <footer className="overflow-hidden rounded-xl border border-slate-200 bg-slate-900 text-slate-300 shadow-lg">
          <div className="grid gap-4 px-4 py-5 sm:grid-cols-2">
            <div>
              <p className="text-sm font-bold text-white">{siteName}</p>
              {address ? (
                <p className="mt-2 text-xs leading-relaxed text-slate-300">{address}</p>
              ) : (
                <p className="mt-2 text-xs italic text-slate-500">Chưa nhập địa chỉ</p>
              )}
            </div>
            <div className="space-y-2 text-xs">
              {hotline && <p>{hotline}</p>}
              {email && <p>{email}</p>}
              {!hotline && !email && <p className="italic text-slate-500">Chưa nhập hotline / email</p>}
            </div>
          </div>

          {socials.length > 0 && (
            <div className="space-y-2 border-t border-white/10 px-4 py-3">
              <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Kết nối</p>
              <div className="flex flex-wrap gap-2">
                {socials.map((s) => (
                  <span
                    key={s.label}
                    className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2.5 py-1 text-[11px] text-white"
                  >
                    <ExternalLink size={10} />
                    {s.label}
                  </span>
                ))}
              </div>
            </div>
          )}
          {socials.length === 0 && (
            <div className="border-t border-white/10 px-4 py-3 text-sm text-slate-500">
              Chưa có link mạng xã hội — thêm ở mục &quot;Mạng xã hội&quot;.
            </div>
          )}
        </footer>
      </div>
    </PreviewModalShell>
  );
}

